import * as actions from '../../actions/actions'
import update from "immutability-helper";

const initialState = {
  files: null,
  error: null,
  hasModal: false,
  hasUploadModal: false,
  hasErrorUploadModal: false,
  hasNegativeModal: false,
  hasPositiveModal: false,
  hasUploadEmptyModal: false,
  hasUploadErrorModal: false,
  hasFileRowLimitModal: false,
  hasApprovalAvailabilityModal: false,
  approveResponse: null,
  currentOTP: "",
  selectedFileStatus: "",
  fileUpload : {
    fileToUpload: {},
    contoCorrente: '',
    campaignId:'',
    bankId:'',
  },
  fileName: '',
  totalErrorNumber: 0,
  emptyFile: false,
  fileId: '',
  file: '',
  idBank: '',
  status: '',
  currentStatus: ''
}

export default function file(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_FILES_SUCCESS:
      return fetchFilesSuccess(state, action)
    case actions.FETCH_FILES_FAILURE:
      return fetchFilesFailure(state, action)
    case actions.APPROVE_FILE_SUCCESS:
      return approveFileSuccess(state,action)
    case actions.TOGGLE_APPROVAL_MODAL:
      return toggleOTPModal(state,action)
    case actions.APPROVE_OTP_CHANGE:
      return updateOTP(state,action)
    case actions.UPDATE_SELECTED_FILE_STATUS:
      return updateSelectedFileStatus(state,action)
    case actions.FILE_UPLOAD_SUCCESS:
      return fileUploadSuccess(state, action)
    case actions.FILE_UPLOAD_EMPTY_FILE:
      return fileUploadEmpty(state, action)
    case actions.FILE_UPLOAD_FAILURE:
      return fileUploadFailure(state, action)
    case actions.FILE_UPLOAD_FILE_FILED_CHANGE:
      return fileUploadFileFieldChange(state, action)
    case actions.FILE_UPLOAD_CLEAN:
      return fileUploadClean(state, action)
    case actions.FILE_UPLOAD_CONTO_CORRENTE_FILED_CHANGE:
      return fileUploadContoCorrenteFieldChange(state, action)
    case actions.FILE_UPLOAD_CAMPAIGN_FILED_CHANGE:
      return fileUploadCampaignFieldChange(state, action)
    case actions.TOGGLE_UPLOAD_MODAL:
      return toggleUploadModal(state,action)
    case actions.TOGGLE_POSITIVE_UPLOAD_MODAL:
      return togglePositiveModal(state,action)
    case actions.TOGGLE_NEGATIVE_UPLOAD_MODAL:
      return toggleNegativeModal(state,action)
    case actions.TOGGLE_EMPTY_UPLOAD_MODAL:
      return toggleUploadEmptyModal(state,action)
    case actions.TOGGLE_FILE_ROW_LIMIT_UPLOAD_MODAL:
      return toggleFileRowLimitUploadModal(state,action)
    case actions.TOGGLE_APPROVAL_AVAILABILITY_MODAL:
        return toggleApprovalAvailabilityModal(state, action)
    case actions.TOGGLE_FILE_ERROR_UPLOAD_MODAL:
      return toggleFileErrorUploadModal(state,action)
    case actions.FILE_UPLOAD_ERROR_FILE_FILED_CHANGE:
      return fileUploadErrorFileFieldChange(state, action)
    case actions.FILE_UPLOAD_TOGGLE_EMPTY_FILE:
      return toggleEmptyModal(state,action)
    default:
      return state
  }
}

const updateSelectedFileStatus = (state, action) => {
  return update(
      state,
      {selectedFileStatus: {$set: action.value}}
  )
}

const toggleApprovalAvailabilityModal = (state, action) => {
    return update(
        state,
        {
            hasApprovalAvailabilityModal: {$set: !state.hasApprovalAvailabilityModal},
            //file, idBank, status, currentStatus
            currentStatus: {$set: state.hasApprovalAvailabilityModal === true ? null : action.value.currentStatus},
            file: {$set: state.hasApprovalAvailabilityModal === true ? null : action.value.file},
            idBank: {$set: state.hasApprovalAvailabilityModal === true ? null : action.value.idBank},
            status: {$set: state.hasApprovalAvailabilityModal === true ? null : action.value.status}
        }
    )
}

const updateOTP = (state, action) => {
  return update(
      state,
      {currentOTP: {$set: action.value}}
  )
}

const fetchFilesSuccess = (state, action) => {
  return {
    ...state,
    error: null,
    files: action.files
  }
}

const fetchFilesFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    files: null
  }
}

const approveFileSuccess = (state,action) => {
  return {
    ...state,
    hasModal:true,
    approveResponse: action.files,
  }
}
const toggleOTPModal = (state,action) => {
  return {
    ...state,
    hasModal:!state.hasModal,
  }
}

const toggleUploadModal = (state,action) => {
  return {
    ...state,
    hasUploadModal:!state.hasUploadModal,
  }
}
const toggleFileErrorUploadModal = (state,action) => {
  return update(
      state,
      {
        hasErrorUploadModal: {$set: !state.hasErrorUploadModal},
        fileId: {$set: state.hasErrorUploadModal === true ? null: action.value.file},
        fileUpload: {
          bankId: {$set: state.hasErrorUploadModal === true ? null: action.value.bankId}
        }
      }
  )
}

const togglePositiveModal = (state,action) => {
  return update(
      state,
      {
        hasPositiveModal: {$set: !state.hasPositiveModal},
        totalErrorNumber: {$set: state.hasPositiveModal === true ? null: action.value.errors},
        fileName: {$set: state.hasPositiveModal === true ? null: action.value.fileName}
      }
  )
}

const toggleNegativeModal = (state,action) => {
  return update(
      state,
      {
        hasNegativeModal: {$set: !state.hasNegativeModal},
        totalErrorNumber: {$set: state.hasNegativeModal === true ? null: action.value.errors},
        fileName: {$set: state.hasNegativeModal === true ? null: action.value.fileName}
      }
  )
}

const toggleUploadEmptyModal = (state,action) => {
  return update(
      state,
      {
        hasUploadEmptyModal: {$set: !state.hasUploadEmptyModal},
        totalErrorNumber: {$set: state.hasUploadEmptyModal === true ? null: action.value.errors},
        fileName: {$set: state.hasUploadEmptyModal === true ? null: action.value.fileName}
      }
  )
}

const toggleFileRowLimitUploadModal = (state,action) => {
  return update(
      state,
      {
        hasFileRowLimitModal: {$set: !state.hasFileRowLimitModal},
        totalErrorNumber: {$set: state.hasFileRowLimitModal === true ? null: action.value.errors},
        fileName: {$set: state.hasFileRowLimitModal === true ? null: action.value.fileName}
      }
  )
}


const fileUploadContoCorrenteFieldChange = (state, action) => {
  return update(
      state,
      {
        fileUpload: {
          contoCorrente: {$set: action.value}
        }
      }
  )
}

const fileUploadCampaignFieldChange = (state, action) => {
  return update(
      state,
      {
        fileUpload: {
          campaignId: {$set: action.value.idLogo},
          bankId: {$set: action.value.bankId}
        }
      }
  )
}

const fileUploadSuccess = (state, action) => {
  return {
    ...state,
    error: ''
  }
}

const fileUploadFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const fileUploadErrorFileFieldChange = (state, action) => {
  return update(
      state,
      {
        fileUpload: {
          fileToUpload: {$set: action.value}
        },
        fileName: {$set: action.value.name}}
  )
}

const fileUploadFileFieldChange = (state, action) => {
  return update(
      state,
      {
        fileUpload: {
          fileToUpload: {$set: action.value}
        },
        fileName: {$set: action.value.name}}
  )
}
const fileUploadEmpty = (state, action) => {
  return update(
      state,
      {emptyFile: {$set: true}}
  )
}

const fileUploadClean = (state, action) => {
  return initialState
}

const toggleEmptyModal  = (state,action) => {
  return update(
      state,
      {emptyFile: {$set: !state.emptyFile}, error: {$set: null}}
  )
}